import api, { unwrap } from './client';
import type { ApiResponse, PageResponse, SearchParams } from '@/types/api';
import type {
  ProductTaxRequest,
  ProductTaxResponse,
  TaxPreviewResponse,
  TaxRuleRequest,
  TaxRuleResponse,
} from '@/types/taxRule';

export const taxRulesApi = {
  list: (params?: SearchParams) =>
    unwrap(api.get<ApiResponse<PageResponse<TaxRuleResponse>>>('/v1/tax-rules', { params })),

  get: (id: number) => unwrap(api.get<ApiResponse<TaxRuleResponse>>(`/v1/tax-rules/${id}`)),

  create: (body: TaxRuleRequest) =>
    unwrap(api.post<ApiResponse<TaxRuleResponse>>('/v1/tax-rules', body)),

  update: (id: number, body: TaxRuleRequest) =>
    unwrap(api.put<ApiResponse<TaxRuleResponse>>(`/v1/tax-rules/${id}`, body)),

  delete: (id: number) => unwrap(api.delete<ApiResponse<null>>(`/v1/tax-rules/${id}`)),

  assignProductTax: (body: ProductTaxRequest) =>
    unwrap(api.post<ApiResponse<ProductTaxResponse>>('/v1/tax-rules/product-mapping', body)),

  removeProductTax: (productId: number, taxRuleId: number) =>
    unwrap(
      api.delete<ApiResponse<null>>('/v1/tax-rules/product-mapping', {
        params: { productId, taxRuleId },
      }),
    ),

  preview: (storeId: number, productId: number) =>
    unwrap(
      api.get<ApiResponse<TaxPreviewResponse>>('/v1/tax-rules/preview', {
        params: { storeId, productId },
      }),
    ),
};
